import { render, staticRenderFns } from "./NavItemGroup.vue?vue&type=template&id=09e7f4a2"
import script from "./NavItemGroup.vue?vue&type=script&lang=js"
export * from "./NavItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports